import { object, string } from "superstruct";

const CreateDraftOrderResponseSchema = object({
    invoiceUrl: string(),
});
export default CreateDraftOrderResponseSchema;
